import { axiosInstance } from './api';
import * as ActionTypes from '../store/ActionTypes';

export const actionCreators = {
    getBranches: (branches) => ({ type: ActionTypes.getBranches, payload: branches }),
    getProductLevels: (productLevels) => ({ type: ActionTypes.getProductLevels, payload: productLevels }),
    getProduct: (product) => ({ type: ActionTypes.getProduct, payload: product }),
    getProductDetailTemplate: (template) => ({ type: ActionTypes.getProductDetailTemplate, payload: template }),
    updateProduct: (product) => ({ type: ActionTypes.updateProduct, payload: product }),
    createProduct: (product) => ({ type: ActionTypes.createProduct, payload: product }),
    setProduct: (product) => ({ type: ActionTypes.getProduct, payload: product }),
    updateResponse: (response) => ({ type: ActionTypes.updateResponse, payload: response })
}
export const getPrimaryProductById = (productLevelId, branchId) => {
    const url = `Product/GetPrimaryProductById?productLevelId=${productLevelId}&branchId=${branchId}`;
    return axiosInstance().get(url);
}

export const getProductsByProductLevelAndBranch = (productLevelId, branchId) => {
    const url = `Product/GetProductsByProductLevelAndBranchAsync?productLevelId=${productLevelId}&branchId=${branchId}`;
    return axiosInstance().get(url);
}

export const getProducts = (filter, startDate, endDate, promoCodeId) => {
    const url = `Product/GetProductsForPromoCode?branchId=${filter}&startDate=${startDate}&endDate=${endDate}&promoCodeId=${promoCodeId}`;
    return axiosInstance().get(url);
}

export const getProductsPaginated = (filter, pageNumber, pageSize, orderBy, descending, onlyActive) => {
    const url = `Product/GetProductsByFilterPaginatedAsync?filter=${filter}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderBy=${orderBy}&descending=${descending}&onlyActive=${onlyActive}`;
    return axiosInstance().get(url);
}


export const getProduct = (callback, context, id) => {
    return dispatch => {
        const url = `Product/GetProductById/${id}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getProduct(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getBranches = (callback, context, onlyActive) => {
    return dispatch => {
        let url = `Branch/GetAllBranches`;
        if (onlyActive) {
            url += `?onlyActive=${onlyActive}`;
        }
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getBranches(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getProductDetailTemplate = (callback, context, id) => {
    return dispatch => {
        const url = `productdetailtemplate/GetProductDetailTemplateIdById/${id}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getProductDetailTemplate(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getProductLevels = (callback, context) => {
    return dispatch => {
        const url = `productLevel/GetAllAsync`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getProductLevels(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const updateProduct = (product) => {
    return dispatch => {
        const url = `Product/PutAsync`;
        return axiosInstance().put(url, product).then(response => {
            dispatch(actionCreators.updateProduct(response))
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const updateResponse = (response) => {
    return dispatch => {
        dispatch(actionCreators.updateResponse(response));
    }
}

export const createProduct = (product, productOption) => {
    console.log('api create ')
    return dispatch => {
        let url = `Product/PostAsync`;
        if (productOption) {
            url += `?productOption=${productOption}`;
        }
        return axiosInstance().post(url, product).then(response => {
            dispatch(actionCreators.updateProduct(response))
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}


